<div class="page">
    <app-page-header [title]="'myProfile.title' | translate">
      <button type="button" (click)="goToPreview()" class="btn btn-secondary">
          <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          {{ 'myProfile.previewProfile' | translate }}
      </button>
      <button type="button" (click)="toggleEdit()" class="btn btn-primary">
          @if (isEditMode()) {
            <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
            {{ 'myProfile.viewProfile' | translate }}
          } @else {
            <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            {{ 'myProfile.editProfile' | translate }}
          }
      </button>
    </app-page-header>

    @if (isLoading()) {
      <app-branded-loader [label]="'common.loading' | translate" />
    } @else {
      @if (!isEditMode()) {
        <!-- VIEW MODE -->
        @if (human(); as currentHuman) {
          <!-- Profile Header / Banner -->
          <div class="relative mb-12 flex min-h-64 items-end overflow-hidden rounded-3xl bg-slate-900 shadow-xl md:min-h-80">
            <img [src]="currentHuman.coverImageUrl || '/assets/club-background-forest.webp'" alt=""
                 class="absolute inset-0 h-full w-full object-cover opacity-60 blur-[2px]">
            <div class="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent"></div>

            <div class="relative z-10 flex w-full min-w-0 flex-col gap-4 p-6 sm:flex-row sm:items-end sm:gap-8 md:p-10">
              <div class="relative shrink-0 self-start sm:self-auto">
                <app-human-avatar
                  [imageUrl]="currentHuman.imageUrl"
                  [gender]="currentHuman.gender"
                  [name]="currentHuman.name"
                  class="h-24 w-24 overflow-hidden rounded-3xl border-4 border-white shadow-2xl dark:border-slate-800 md:h-36 md:w-36" />
                <div class="absolute -bottom-2 -right-2 rounded-xl border-2 border-white bg-white/90 p-1.5 shadow-lg dark:border-slate-800 dark:bg-slate-800">
                  <span class="text-lg leading-none">{{ flagEmoji }}</span>
                </div>
              </div>
              <div class="min-w-0">
                <h2 class="profile-title mb-3 text-white drop-shadow-lg">{{ currentHuman.name }}</h2>
                <div class="flex flex-wrap gap-2">
                  <span class="rounded-full bg-white/20 px-3 py-1 text-xs font-bold uppercase tracking-wider text-white backdrop-blur-md">
                    {{ currentHuman.age }} {{ 'humanProfile.years' | translate }}
                  </span>
                  <span class="rounded-full bg-white/20 px-3 py-1 text-xs font-bold uppercase tracking-wider text-white backdrop-blur-md">
                    {{ currentHuman.gender === 'Male' ? ('myProfile.male' | translate) : ('myProfile.female' | translate) }}
                  </span>
                  @if(currentHuman.club) {
                    <span class="accent-solid max-w-full truncate rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wider">
                      {{ currentHuman.club }}
                    </span>
                  }
                </div>
              </div>
            </div>
          </div>

          <!-- Rare maintenance tools stay hidden until explicitly requested. -->
          <details class="group mb-10">
            <summary class="ml-auto flex w-fit cursor-pointer list-none items-center gap-2 rounded-xl px-3 py-2 text-xs font-semibold text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600 dark:hover:bg-white/5 dark:hover:text-slate-300">
              <svg class="h-4 w-4 transition-transform group-open:rotate-90" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
                <path d="m9 6 6 6-6 6" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
              </svg>
              {{ translationLanguageIsFrench ? 'Options avancées du profil' : 'Advanced profile options' }}
            </summary>
            <div class="mt-3 rounded-2xl border border-slate-200/70 bg-slate-50/60 p-3 dark:border-white/10 dark:bg-white/[0.025]">

          <!-- Change the login password -->
          <div class="mb-3 rounded-2xl bg-white p-5 dark:bg-slate-900">
            <div class="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
              <div>
                <h3 class="text-lg font-black text-slate-900 dark:text-slate-100">
                  {{ 'auth.change.title' | translate }}
                </h3>
                <p class="mt-1 max-w-2xl text-sm text-slate-500 dark:text-slate-400">
                  {{ 'auth.change.desc' | translate }}
                </p>
              </div>
              <button type="button"
                      (click)="showPasswordChange.set(!showPasswordChange()); passwordChanged.set(false)"
                      class="btn btn-secondary shrink-0">
                {{ (showPasswordChange() ? 'auth.change.close' : 'auth.change.open') | translate }}
              </button>
            </div>

            @if (showPasswordChange()) {
              <div class="mt-6 max-w-md border-t border-slate-100 pt-6 dark:border-slate-800">
                <app-new-password-form submitLabel="auth.change.button"
                                       (changed)="showPasswordChange.set(false); passwordChanged.set(true)" />
              </div>
            }

            @if (passwordChanged()) {
              <p class="mt-5 rounded-2xl bg-emerald-50 px-5 py-4 text-sm font-bold text-emerald-700 dark:bg-emerald-900/20 dark:text-emerald-300" role="status">
                {{ 'auth.change.done' | translate }}
              </p>
            }
          </div>

          <!-- Merge another unclaimed result profile into this account -->
          <div class="rounded-2xl bg-white p-5 dark:bg-slate-900">
            <div class="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
              <div>
                <h3 class="text-lg font-black text-slate-900 dark:text-slate-100">
                  {{ 'myProfile.merge.title' | translate }}
                </h3>
                <p class="mt-1 max-w-2xl text-sm text-slate-500 dark:text-slate-400">
                  {{ 'myProfile.merge.description' | translate }}
                </p>
              </div>
              <button type="button"
                      (click)="toggleMergeSearch()"
                      class="btn btn-secondary shrink-0">
                {{ (showMergeSearch() ? 'myProfile.merge.close' : 'myProfile.merge.open') | translate }}
              </button>
            </div>

            @if (showMergeSearch()) {
              <div class="mt-6 border-t border-slate-100 pt-6 dark:border-slate-800">
                <label for="merge-profile-search"
                       class="mb-2 block text-xs font-black uppercase tracking-widest text-slate-500">
                  {{ 'myProfile.merge.searchLabel' | translate }}
                </label>
                <div class="relative">
                  <input id="merge-profile-search"
                         type="search"
                         [ngModel]="mergeQuery()"
                         (ngModelChange)="mergeQuery.set($event); searchMergeCandidates()"
                         [placeholder]="'myProfile.merge.searchPlaceholder' | translate"
                         class="field py-4 pr-12">
                  @if (isSearchingMerge()) {
                    <span class="absolute right-5 top-1/2 h-5 w-5 -translate-y-1/2 animate-spin rounded-full border-2 border-[color:var(--region-accent)] border-t-transparent"></span>
                  }
                </div>

                @if (mergeCandidates().length > 0) {
                  <div class="mt-4 grid gap-3">
                    @for (candidate of mergeCandidates(); track candidate.id) {
                      <div class="flex flex-col gap-4 rounded-2xl border border-slate-200 p-4 sm:flex-row sm:items-center sm:justify-between dark:border-slate-700">
                        <div>
                          <p class="font-black text-slate-900 dark:text-white">{{ candidate.name }}</p>
                          <p class="mt-1 text-xs font-bold uppercase tracking-wider text-slate-400">
                            {{ candidate.club || ('clubsKiosk.independents' | translate) }}
                          </p>
                        </div>
                        <button type="button"
                                (click)="mergeCandidate(candidate)"
                                [disabled]="mergingHumanId() !== null"
                                class="btn btn-primary disabled:cursor-wait">
                          @if (mergingHumanId() === candidate.id) {
                            {{ 'myProfile.merge.merging' | translate }}
                          } @else {
                            {{ 'myProfile.merge.action' | translate }}
                          }
                        </button>
                      </div>
                    }
                  </div>
                } @else if (mergeQuery().length >= 3 && !isSearchingMerge() && !mergeNotice()) {
                  <p class="mt-4 text-sm italic text-slate-400">
                    {{ 'myProfile.merge.noResults' | translate }}
                  </p>
                }
              </div>
            }

            @if (mergeNotice(); as notice) {
              <p class="mt-5 rounded-2xl px-5 py-4 text-sm font-bold"
                 [class.bg-emerald-50]="notice.type === 'success'"
                 [class.text-emerald-700]="notice.type === 'success'"
                 [class.bg-red-50]="notice.type === 'error'"
                 [class.text-red-700]="notice.type === 'error'">
                {{ notice.text }}
              </p>
            }
          </div>

          <!-- Merge two of my dogs into one (duplicate names from imports) -->
          <div class="mt-3 rounded-2xl bg-white p-5 dark:bg-slate-900">
            <div class="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
              <div>
                <h3 class="text-lg font-black text-slate-900 dark:text-slate-100">
                  {{ 'myProfile.mergeDogs.title' | translate }}
                </h3>
                <p class="mt-1 max-w-2xl text-sm text-slate-500 dark:text-slate-400">
                  {{ 'myProfile.mergeDogs.description' | translate }}
                </p>
              </div>
              <button type="button"
                      (click)="toggleDogMerge()"
                      class="btn btn-secondary shrink-0">
                {{ (showDogMerge() ? 'myProfile.mergeDogs.close' : 'myProfile.mergeDogs.open') | translate }}
              </button>
            </div>

            @if (showDogMerge()) {
              <div class="mt-6 grid gap-4 border-t border-slate-100 pt-6 dark:border-slate-800 md:grid-cols-2">
                <div>
                  <label for="merge-source-dog"
                         class="mb-2 block text-xs font-black uppercase tracking-widest text-slate-500">
                    {{ 'myProfile.mergeDogs.sourceLabel' | translate }}
                  </label>
                  <select id="merge-source-dog"
                          [ngModel]="mergeSourceDogId()"
                          (ngModelChange)="mergeSourceDogId.set($event)"
                          class="field py-4">
                    <option value="">{{ 'myProfile.mergeDogs.selectPlaceholder' | translate }}</option>
                    @for (dog of personalDogs(); track dog.id) {
                      <option [value]="dog.id" [disabled]="dog.id === mergeTargetDogId()">{{ dog.name }} · {{ dog.breed | breedName }}</option>
                    }
                  </select>
                </div>
                <div>
                  <label for="merge-target-dog"
                         class="mb-2 block text-xs font-black uppercase tracking-widest text-slate-500">
                    {{ 'myProfile.mergeDogs.targetLabel' | translate }}
                  </label>
                  <select id="merge-target-dog"
                          [ngModel]="mergeTargetDogId()"
                          (ngModelChange)="mergeTargetDogId.set($event)"
                          class="field py-4">
                    <option value="">{{ 'myProfile.mergeDogs.selectPlaceholder' | translate }}</option>
                    @for (dog of personalDogs(); track dog.id) {
                      <option [value]="dog.id" [disabled]="dog.id === mergeSourceDogId()">{{ dog.name }} · {{ dog.breed | breedName }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="mt-5 flex justify-end">
                <button type="button"
                        (click)="mergeDogs()"
                        [disabled]="!canMergeDogs()"
                        class="btn btn-primary">
                  @if (mergingDog()) {
                    {{ 'myProfile.mergeDogs.merging' | translate }}
                  } @else {
                    {{ 'myProfile.mergeDogs.action' | translate }}
                  }
                </button>
              </div>
            }

            @if (dogMergeNotice(); as dogNotice) {
              <p class="mt-5 rounded-2xl px-5 py-4 text-sm font-bold"
                 [class.bg-emerald-50]="dogNotice.type === 'success'"
                 [class.text-emerald-700]="dogNotice.type === 'success'"
                 [class.bg-red-50]="dogNotice.type === 'error'"
                 [class.text-red-700]="dogNotice.type === 'error'">
                {{ dogNotice.text }}
              </p>
            }
          </div>
            </div>
          </details>

          <div class="mb-12">
            <div class="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <span class="text-sm font-bold text-slate-700 dark:text-slate-200">{{ 'humanProfile.statsPeriod' | translate }}</span>
              <app-styled-select [options]="statsPeriodOptions()"
                [value]="statsScope() === 'all' ? 'all' : selectedSeasonStart().toString()"
                [ariaLabel]="'humanProfile.statsPeriod' | translate" [fullWidth]="true"
                class="w-full sm:w-64" density="comfortable" (valueChange)="setStatsPeriod($event)" />
            </div>
            <app-human-profile-stats
              [results]="scopedResults()"
            />
          </div>

          <div class="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <!-- Sidebar: My Dogs -->
            <div class="lg:col-span-1 space-y-8">
              <div class="bg-white dark:bg-slate-900 rounded-3xl p-8 shadow-xl border border-slate-200 dark:border-slate-800">
                <h3 class="text-2xl font-black text-slate-900 dark:text-slate-100 mb-8 flex items-center gap-4">
                  <span class="accent-solid w-10 h-10 rounded-2xl flex items-center justify-center">
                    <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2a9.984 9.984 0 00-6.333 17.167l.166.167.167.167A9.984 9.984 0 0022 12c0-5.523-4.477-10-10-10zm-2.083 4.5a2.417 2.417 0 110 4.833 2.417 2.417 0 010-4.833zm4.166 0a2.417 2.417 0 110 4.833 2.417 2.417 0 010-4.833zm2.5 5a2.417 2.417 0 110 4.833 2.417 2.417 0 010-4.833zm-9.166 0a2.417 2.417 0 110 4.833 2.417 2.417 0 010-4.833zm4.583 3.75a3.75 3.75 0 110 7.5 3.75 3.75 0 010-7.5z" />
                    </svg>
                  </span>
                  {{ translationLanguageIsFrench ? 'Chiens avec lesquels j’ai couru' : 'Dogs I raced with' }}
                </h3>
                <p class="mb-4 text-xs text-slate-500 dark:text-slate-400">{{ translationLanguageIsFrench ? 'La participation à une course ne signifie pas que le chien t’appartient. Indique ceux qui t’ont été prêtés.' : 'Racing with a dog does not mean you own it. Mark dogs that were lent to you.' }}</p>
                @if (dogRelationshipError()) {
                  <p class="mb-3 text-xs text-red-600" role="alert">{{ translationLanguageIsFrench ? 'Impossible de charger ou d’enregistrer le statut des chiens. Réessaie.' : 'Could not load or save dog relationships. Please try again.' }}</p>
                }
                <p class="mb-4 text-[10px] font-black uppercase tracking-widest text-slate-400">
                  {{ translationLanguageIsFrench ? 'Classement par nombre de courses' : 'Ranking by number of races' }}
                </p>
                <div class="space-y-6">
                  @for (dog of racingDogs(); track dog.id; let rank = $index) {
                    <div class="group relative p-4 rounded-3xl border border-slate-100 dark:border-slate-800 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-all"
                         >
                      <div class="flex items-start gap-3">
                        <span class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-slate-900 text-xs font-black text-white dark:bg-white dark:text-slate-900">{{ rank + 1 }}</span>
                        @if (dog.imageUrl) {
                          <img [src]="dog.imageUrl" class="w-14 h-14 rounded-2xl object-cover shadow-md">
                        } @else {
                          <div class="w-14 h-14 rounded-2xl bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-400">🐾</div>
                        }
                        <div class="min-w-0 flex-1">
                        <h4 class="font-black text-slate-900 dark:text-slate-100 group-hover:text-[color:var(--accent-logo)] transition-colors"><a [routerLink]="['/dog-profile', dog.id]" class="after:absolute after:inset-0 after:rounded-3xl focus-visible:outline-none focus-visible:after:ring-2 focus-visible:after:ring-slate-400">{{ dog.name }} @if (dog.age !== null && dog.age !== undefined) { <span class="font-semibold text-slate-400">({{ dog.age }} {{ 'humanProfile.years' | translate }})</span> }</a></h4>
                        <span class="my-1 inline-block rounded-full px-2 py-0.5 text-[10px] font-bold" [class]="isBorrowedDog(dog) ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300' : 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300'">
                          {{ translationLanguageIsFrench ? (isBorrowedDog(dog) ? 'Chien prêté' : 'Mon chien') : (isBorrowedDog(dog) ? 'Borrowed dog' : 'My dog') }}
                        </span>
                        @if (dog.ownerId === human()?.id) {
                          <button type="button" (click)="$event.stopPropagation(); toggleBorrowedDog(dog)" [disabled]="savingDogRelationship() !== null" class="relative z-10 block py-1 text-xs font-semibold text-slate-500 underline underline-offset-2 hover:text-accent disabled:opacity-50">
                            {{ translationLanguageIsFrench ? (isBorrowedDog(dog) ? 'C’est mon chien' : 'Ce chien m’a été prêté') : (isBorrowedDog(dog) ? 'This is my dog' : 'This dog was lent to me') }}
                          </button>
                        }
                        <p class="text-xs font-bold text-slate-400 tracking-wide">{{ dog.breed | breedName }}</p>
                        <p class="text-[11px] font-bold text-slate-400 uppercase tracking-widest mt-0.5">{{ (dog.gender === 'Male' ? 'myProfile.dogMale' : 'myProfile.dogFemale') | translate }}</p>
                        </div>
                      </div>
                      <div class="mt-4 grid grid-cols-2 gap-2">
                        <div class="rounded-xl bg-slate-100 px-3 py-2 dark:bg-slate-800"><strong class="block text-lg text-slate-900 dark:text-white">{{ dogStats(dog.id).races }}</strong><span class="text-[10px] font-bold uppercase text-slate-400">{{ translationLanguageIsFrench ? 'Courses' : 'Races' }}</span></div>
                        <div class="rounded-xl bg-slate-100 px-3 py-2 dark:bg-slate-800"><strong class="block text-lg text-slate-900 dark:text-white">{{ dogStats(dog.id).distance | distance }} km</strong><span class="text-[10px] font-bold uppercase text-slate-400">Distance</span></div>
                      </div>
                      @if (dogStats(dog.id).disciplines.length) {
                        <div class="mt-3 flex flex-wrap gap-1.5">
                          @for (discipline of dogStats(dog.id).disciplines; track discipline.name) {
                            <span class="rounded-lg bg-slate-100 px-2 py-1 text-[10px] font-bold text-slate-600 dark:bg-slate-800 dark:text-slate-300">{{ discipline.name }} · {{ discipline.races }} · {{ discipline.distance | distance }} km</span>
                          }
                        </div>
                      }
                    </div>
                  } @empty {
                    <div class="text-center py-8">
                      <p class="text-slate-400 font-bold italic">{{ 'myProfile.noDogs' | translate }}</p>
                    </div>
                  }
                </div>
              </div>
            </div>

            <!-- Main Content: Race History -->
            <div class="lg:col-span-2">
              <div class="bg-white dark:bg-slate-900 rounded-3xl shadow-xl border border-slate-200 dark:border-slate-800 overflow-hidden">
                <div class="p-8 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
                  <h3 class="text-2xl font-black text-slate-900 dark:text-slate-100 uppercase tracking-tight">{{ 'teamProfile.raceHistory' | translate }}</h3>
                  <span class="px-5 py-2 bg-slate-100 dark:bg-slate-800 rounded-2xl text-xs font-black text-slate-500 uppercase tracking-widest">
                    {{ totalRaces() }} {{ 'humanProfile.stats.races' | translate }}
                  </span>
                </div>
                
                <div class="p-6 md:p-8">
                  @if (resultsBySeason().length === 0) {
                    <div class="py-20 text-center">
                      <div class="flex flex-col items-center opacity-40">
                        <svg class="w-16 h-16 text-slate-300 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M9.172 9.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p class="text-slate-400 font-black uppercase text-sm tracking-widest">{{ 'myProfile.noRaces' | translate }}</p>
                      </div>
                    </div>
                  } @else {
                    <div class="space-y-10">
                      @for (season of resultsBySeason(); track season[0]) {
                        <section>
                          <div class="flex items-center gap-3 mb-4 px-1">
                            <h4 class="text-sm font-black text-slate-900 dark:text-slate-100 uppercase tracking-widest">
                              {{ 'common.season' | translate }} {{ seasonLabel(season[0]) }}
                            </h4>
                            <span class="px-3 py-1 bg-slate-100 dark:bg-slate-800 rounded-full text-[10px] font-black text-slate-500 uppercase tracking-widest">
                              {{ season[1].length }} {{ 'humanProfile.stats.races' | translate }}
                            </span>
                            <div class="flex-1 h-px bg-slate-100 dark:bg-slate-800"></div>
                          </div>
                          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            @for (result of season[1]; track result.id) {
                              <article class="group rounded-2xl border border-slate-100 dark:border-slate-800 bg-slate-50/70 dark:bg-slate-800/40 p-5 transition-all hover:shadow-lg hover:-translate-y-0.5">
                                <div class="flex items-start justify-between gap-3 mb-3">
                                  <div class="min-w-0">
                                    <a [routerLink]="['/race-detail', result.event?.id]"
                                       class="block break-words text-sm font-black text-slate-900 dark:text-slate-100 group-hover:text-[color:var(--accent-logo)] transition-colors underline-offset-4 hover:underline">
                                      {{ result.event?.name || result.race.name }}
                                    </a>
                                    @if (result.event?.name && result.race.name !== result.event?.name) {
                                      <p class="mt-1 text-xs font-semibold text-slate-600 dark:text-slate-300">{{ result.race.name }}</p>
                                    }
                                    <p class="text-[10px] font-bold text-slate-400 uppercase tracking-wider mt-1">{{ formatDate(result.event?.date || '') }}</p>
                                  </div>
                                  <span class="shrink-0 font-mono text-sm font-black text-slate-700 dark:text-slate-200">
                                    {{ result.statusCode ? (result.statusCode | resultStatus:result.statusLabel:result.statusRaw) : (result.statusLabel || formatTime(result.timeSeconds)) }}
                                  </span>
                                </div>
                                <div class="flex flex-wrap items-center gap-2 mb-3">
                                  <span class="accent-soft px-2.5 py-1 rounded-lg text-[10px] font-black uppercase tracking-wider">
                                    {{ (result.discipline ?? result.race.discipline ?? result.race.name) | disciplineLabel }}
                                  </span>
                                  @if (result.race.distanceKm) {
                                    <span class="px-2.5 py-1 bg-slate-100 dark:bg-slate-700/60 rounded-lg text-[10px] font-black text-slate-500 dark:text-slate-300 uppercase tracking-wider">
                                      {{ result.race.distanceKm | distance }} km
                                    </span>
                                  }
                                  @if (result.team?.dog; as dog) {
                                    <a [routerLink]="['/dog-profile', dog.id]"
                                       class="px-2.5 py-1 bg-slate-100 dark:bg-slate-800 rounded-lg text-[10px] font-black text-slate-700 dark:text-slate-200 uppercase tracking-wider hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors">
                                      {{ dog.name }}
                                    </a>
                                  }
                                </div>
                                <div class="mb-3">
                                  @if (!result.team?.dogId && !result.team?.dog?.id && myDogs().length) {
                                    <label class="block text-xs font-bold text-slate-600 dark:text-slate-300">
                                      {{ translationLanguageIsFrench ? 'Chien avec lequel j’ai couru' : 'Dog I raced with' }}
                                      <select class="mt-1 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200"
                                        [value]="result.team?.dog?.id || ''" [disabled]="savingResultDog() !== null"
                                        (change)="chooseResultDog(result, $event)">
                                        <option value="" disabled>{{ translationLanguageIsFrench ? 'Choisir mon chien' : 'Choose my dog' }}</option>
                                        @for (dog of myDogs(); track dog.id) { <option [value]="dog.id">{{ dog.name }}</option> }
                                      </select>
                                    </label>
                                  } @else if (!result.team?.dog) {
                                    <p class="text-xs text-slate-500">{{ translationLanguageIsFrench ? 'Ajoute un chien dans ton profil pour l’associer à cette course.' : 'Add a dog to your profile to link it to this race.' }}</p>
                                  }
                                  @if (resultDogNotice()?.resultId === result.id) {
                                    <p class="mt-2 text-xs font-semibold" role="status">{{ resultDogNotice()?.text }}</p>
                                  }
                                </div>
                                <div class="flex items-center gap-2 pt-3 border-t border-slate-100 dark:border-slate-700/60">
                                  <span class="text-[10px] font-black text-slate-400 uppercase tracking-widest">{{ 'myProfile.scratch' | translate }}</span>
                                  <span class="text-sm font-black text-slate-900 dark:text-slate-100">
                                    @if (result.position) { #{{ result.position }} } @else { {{ null | displayValue }} }
                                  </span>
                                  <span class="text-[10px] text-slate-400 font-bold">/{{ participantCounts()[result.raceId] || 0 }}</span>
                                  @if (result.category) {
                                    <span class="ml-auto inline-flex items-center gap-1 px-2 py-0.5 rounded-lg text-[10px] font-black uppercase tracking-wider"
                                          [class.bg-yellow-100]="result.categoryRank === 1"
                                          [class.text-yellow-800]="result.categoryRank === 1"
                                          [class.bg-slate-100]="result.categoryRank !== 1"
                                          [class.text-slate-500]="result.categoryRank !== 1">
                                      {{ 'common.categoryShort' | translate }} {{ result.category }}
                                      @if (result.categoryRank) { #{{ result.categoryRank }} } @else { {{ null | displayValue }} }
                                    </span>
                                  }
                                </div>
                              </article>
                            }
                          </div>
                        </section>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        } @else {
          <!-- ONBOARDING MODE -->
          <div class="max-w-4xl mx-auto py-20 px-6 bg-white dark:bg-slate-900 rounded-3xl shadow-2xl border border-slate-200 dark:border-slate-800 text-center relative overflow-hidden">
            <div class="absolute top-0 right-0 w-64 h-64 bg-[color-mix(in_srgb,var(--region-accent)_6%,transparent)] rounded-full -mr-32 -mt-32"></div>
            <div class="absolute bottom-0 left-0 w-64 h-64 bg-[color-mix(in_srgb,var(--region-accent)_4%,transparent)] rounded-full -ml-32 -mb-32"></div>

            <div class="relative z-10">
              <div class="accent-soft w-24 h-24 rounded-3xl flex items-center justify-center mx-auto mb-8">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>

              <h2 class="text-3xl font-black text-slate-900 dark:text-white mb-4 uppercase italic tracking-tight">{{ 'myProfile.onboarding.title' | translate }}</h2>
              <p class="text-slate-500 dark:text-slate-400 mb-12 max-w-lg mx-auto font-medium">
                {{ 'myProfile.onboarding.desc' | translate }}
              </p>

              @if (suggestedProfile() && !showManualSearch()) {
                <!-- SUGGESTED PROFILE CARD -->
                <div class="max-w-md mx-auto mb-12 animate-fade-in">
                  <div class="accent-surface border-2 rounded-3xl p-8 relative overflow-hidden group">
                    <div class="absolute top-0 right-0 w-32 h-32 bg-[color-mix(in_srgb,var(--region-accent)_10%,transparent)] rounded-full -mr-16 -mt-16 transition-transform group-hover:scale-110"></div>
                    
                    <h3 class="text-sm font-black uppercase tracking-widest mb-6">{{ 'myProfile.onboarding.isThisYou' | translate }}</h3>
                    
                    <div class="flex items-center gap-6 mb-8 text-left">
                      <app-human-avatar
                        [imageUrl]="suggestedProfile()?.imageUrl"
                        [gender]="suggestedProfile()?.gender"
                        [name]="suggestedProfile()?.name"
                        class="h-20 w-20 shrink-0 overflow-hidden rounded-2xl bg-white shadow-xl dark:bg-slate-800" />
                      <div>
                        <h4 class="text-2xl font-black text-slate-900 dark:text-white leading-tight mb-1">{{ suggestedProfile()?.name }}</h4>
                        <div class="flex items-center gap-2">
                          <span class="accent-solid px-2 py-0.5 text-[10px] font-black rounded-lg uppercase tracking-wider">{{ suggestedProfile()?.nationality || 'FRA' }}</span>
                          <span class="text-xs font-bold text-slate-500 uppercase tracking-widest">{{ suggestedProfile()?.club || ('clubsKiosk.independents' | translate) }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="space-y-3">
                      <button (click)="linkProfile(suggestedProfile()!)" 
                              class="btn btn-primary w-full py-4">
                        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" />
                        </svg>
                        {{ 'myProfile.onboarding.confirmLink' | translate }}
                      </button>
                      <button (click)="showManualSearch.set(true)" 
                              class="w-full py-3 text-slate-500 hover:text-slate-800 dark:hover:text-slate-200 rounded-xl font-bold text-xs uppercase tracking-widest transition-colors">
                        {{ 'myProfile.onboarding.notMe' | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              } @else {
                <!-- MANUAL SEARCH -->
                <div class="mb-12 max-w-md mx-auto relative animate-fade-in">
                  <input type="text" 
                         [ngModel]="searchQuery()" 
                         (ngModelChange)="searchQuery.set($event); onSearch()"
                         [placeholder]="'myProfile.onboarding.searchPlaceholder' | translate"
                         class="field py-5 pr-14 text-lg">
                  <div class="absolute right-6 top-5 text-slate-400">
                    @if (isSearching()) {
                      <div class="animate-spin rounded-full h-6 w-6 border-2 border-[color:var(--region-accent)] border-t-transparent"></div>
                    } @else {
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    }
                  </div>

                  @if (searchError()) {
                    <div class="relative mt-4 w-full bg-rose-50 dark:bg-rose-950/40 border border-rose-200 dark:border-rose-900 rounded-3xl shadow-2xl p-6 text-center text-rose-700 dark:text-rose-300 text-sm font-bold animate-fade-in">
                      {{ 'myProfile.onboarding.searchError' | translate }}
                    </div>
                  } @else if (searchResults().length > 0 || claimedSearchResults().length > 0) {
                    <div class="relative mt-4 w-full bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-3xl shadow-2xl z-20 overflow-hidden py-2 animate-fade-in">
                      @if (searchResults().length > 0) {
                        @for (h of searchResults(); track h.id) {
                        <div (click)="linkProfile(h)" 
                             class="flex items-center gap-4 px-6 py-4 hover:bg-slate-50 dark:hover:bg-slate-800 transition-all cursor-pointer group">
                          <div class="w-10 h-10 rounded-xl bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-400 group-hover:text-[color:var(--accent-logo)] transition-all">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                            </svg>
                          </div>
                          <div class="text-left">
                            <h4 class="font-black text-slate-900 dark:text-white group-hover:text-[color:var(--accent-logo)] transition-colors">{{ h.name }}</h4>
                            <span class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{{ h.club || ('clubsKiosk.independents' | translate) }}</span>
                          </div>
                        </div>
                        }
                      }
                      @if (claimedSearchResults().length > 0) {
                        <div class="mx-4 mt-2 border-t border-slate-100 px-2 pt-4 dark:border-slate-800">
                          <p class="mb-3 text-xs font-black uppercase tracking-widest text-amber-600 dark:text-amber-400">
                            {{ 'myProfile.onboarding.alreadyLinked' | translate }}
                          </p>
                          @for (h of claimedSearchResults(); track h.id) {
                            <div class="flex items-center gap-4 px-4 py-3 opacity-70" aria-disabled="true">
                              <div class="w-10 h-10 rounded-xl bg-amber-50 dark:bg-amber-950/40 flex items-center justify-center text-amber-500">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                </svg>
                              </div>
                              <div class="text-left">
                                <h4 class="font-black text-slate-900 dark:text-white">{{ h.name }}</h4>
                                <span class="text-[10px] font-bold uppercase tracking-widest text-slate-400">{{ 'myProfile.onboarding.alreadyLinkedShort' | translate }}</span>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  } @else if (searchQuery().length >= 3 && !isSearching()) {
                    <div class="relative mt-4 w-full bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-3xl shadow-2xl p-6 text-center italic text-slate-400 text-sm animate-fade-in">
                      {{ 'myProfile.onboarding.noResults' | translate:searchQuery() }}
                    </div>
                  }
                </div>
              }

              <div class="flex flex-col sm:flex-row items-center justify-center gap-4">
                <span class="text-slate-400 font-bold uppercase tracking-widest text-[10px]">{{ 'myProfile.onboarding.or' | translate }}</span>
                <button (click)="createNewProfile()" 
                        class="btn btn-primary px-10 py-5">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 group-hover:rotate-12 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  {{ 'myProfile.onboarding.createNew' | translate }}
                </button>
              </div>
            </div>
          </div>
        }
      } @else {
        <!-- EDIT MODE -->
        <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" class="space-y-12">
          
          <div class="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <!-- Sidebar: Profile Photo & Basic Info -->
            <div class="lg:col-span-1 space-y-8">
              <div class="bg-white dark:bg-slate-900 rounded-3xl p-10 shadow-xl border border-slate-200 dark:border-slate-800 text-center">
                <div class="relative w-48 h-48 mx-auto mb-8">
                  <app-human-avatar
                    [imageUrl]="profilePhotoPreview()"
                    [gender]="$any(profileForm.get('gender')?.value)"
                    class="h-full w-full overflow-hidden rounded-3xl border-4 border-white shadow-2xl dark:border-slate-800" />
                  <label class="btn-primary absolute -bottom-4 left-1/2 -translate-x-1/2 p-3 rounded-2xl cursor-pointer transition-all border-4 border-white dark:border-slate-800">
                    <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <input type="file" class="hidden" (change)="onProfilePhotoSelected($event)" accept="image/*">
                  </label>
                </div>
                @if (photoError() === 'avatar') {
                  <p class="-mt-2 mb-6 text-xs font-bold text-red-600 dark:text-red-400" role="alert">{{ 'myProfile.photoError' | translate }}</p>
                }

                <div class="space-y-4">
                  <div class="grid grid-cols-2 gap-4">
                    <div>
                      <label class="block text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-2">{{ 'register.firstName' | translate }}</label>
                      <input type="text" formControlName="firstName" 
                             class="field text-center">
                    </div>
                    <div>
                      <label class="block text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-2">{{ 'register.lastName' | translate }}</label>
                      <input type="text" formControlName="lastName" 
                             class="field text-center">
                    </div>
                  </div>
                  <div>
                    <label class="block text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-2">{{ 'register.dob' | translate }}</label>
                    <input type="date" formControlName="dob" 
                           class="field text-center">
                  </div>
                </div>
              </div>

              <div class="bg-white dark:bg-slate-900 rounded-3xl p-10 shadow-xl border border-slate-200 dark:border-slate-800">
                <h3 class="text-xl font-black text-slate-900 dark:text-slate-100 uppercase tracking-tight mb-8">{{ 'myProfile.coverPhoto' | translate }}</h3>
                <div class="relative h-36 overflow-hidden rounded-3xl bg-slate-100 dark:bg-slate-800 mb-6">
                  <img [src]="coverPhotoPreview() || '/assets/club-background-forest.webp'"
                       alt="Cover preview"
                       class="w-full h-full object-cover">
                  <label class="btn-primary absolute bottom-3 right-3 p-2.5 rounded-xl cursor-pointer transition-all">
                    <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <input type="file" class="hidden" (change)="onCoverPhotoSelected($event)" accept="image/*">
                  </label>
                </div>
                @if (photoError() === 'cover') {
                  <p class="mt-2 text-xs font-bold text-red-600 dark:text-red-400" role="alert">{{ 'myProfile.photoError' | translate }}</p>
                }
              </div>

              <div class="bg-white dark:bg-slate-900 rounded-3xl p-10 shadow-xl border border-slate-200 dark:border-slate-800">
                <h3 class="text-xl font-black text-slate-900 dark:text-slate-100 uppercase tracking-tight mb-8">{{ 'myProfile.personalInfo' | translate }}</h3>
                <div class="space-y-6">
                  <div>
                    <label class="block text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-2">{{ 'myProfile.age' | translate }}</label>
                    <input type="number" formControlName="age" 
                           class="field">
                  </div>
                  <div>
                    <label class="block text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-2">{{ 'myProfile.gender' | translate }}</label>
                    <select formControlName="gender" 
                            class="field">
                      <option value="Male">{{ 'myProfile.male' | translate }}</option>
                      <option value="Female">{{ 'myProfile.female' | translate }}</option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-2">{{ 'myProfile.club' | translate }}</label>
                    <app-club-picker [clubName]="human()?.club" [ariaLabel]="'myProfile.club' | translate"
                      inputClass="field"
                      (clubChange)="onClubChange($event)" />
                  </div>
                  <div>
                    <label class="block text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-2">{{ 'myProfile.nationality' | translate }}</label>
                    <select formControlName="nationality" 
                            class="field">
                      <option value="FRA">France 🇫🇷</option>
                      <option value="BEL">Belgique 🇧🇪</option>
                      <option value="ENG">Angleterre 🇬🇧</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Content: Dogs Management -->
            <div class="lg:col-span-2 space-y-8">
              <div class="bg-white dark:bg-slate-900 rounded-3xl p-10 shadow-xl border border-slate-200 dark:border-slate-800">
                <div class="flex items-center justify-between mb-10">
                  <h3 class="text-2xl font-black text-slate-900 dark:text-slate-100 uppercase tracking-tight">{{ 'myProfile.myDogs' | translate }}</h3>
                  <button type="button" (click)="addDog()" 
                          class="btn btn-primary">
                    <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                    </svg>
                    {{ 'myProfile.addDog' | translate }}
                  </button>
                </div>

                <div formArrayName="dogs" class="grid grid-cols-1 md:grid-cols-2 gap-8">
                  @for (dogForm of dogsFormArray.controls; track $index) {
                    <div [formGroupName]="$index" class="relative group p-8 bg-slate-50 dark:bg-slate-800/50 rounded-3xl border border-slate-100 dark:border-slate-800">
                      <button type="button" (click)="removeDog($index)" 
                              class="absolute top-6 right-6 p-2 text-slate-300 hover:text-red-500 transition-all bg-white dark:bg-slate-800 rounded-xl shadow-md">
                        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>

                      <div class="space-y-4">
                        <div>
                          <label class="block text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-2">{{ 'myProfile.dogName' | translate }}</label>
                          <input type="text" formControlName="name" 
                                 class="field">
                        </div>
                        <div>
                          <label class="block text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-2">{{ 'myProfile.dogBreed' | translate }}</label>
                          <input type="text" formControlName="breed" 
                                 class="field">
                        </div>
                        <div class="grid grid-cols-2 gap-4">
                          <div>
                            <label class="block text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-2">{{ 'myProfile.birthYear' | translate }}</label>
                            <input type="number" formControlName="birth_year" min="1900" [max]="currentYear" step="1"
                                   class="field">
                            @if (dogForm.get('birth_year')?.invalid && dogForm.get('birth_year')?.touched) {
                              <p class="mt-2 text-xs text-red-600">{{ translationLanguageIsFrench ? 'Saisis une année de naissance valide, sans date future.' : 'Enter a valid birth year, not a future date.' }}</p>
                            }
                          </div>
                          <div>
                            <label class="block text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-2">{{ 'myProfile.dogGender' | translate }}</label>
                            <select formControlName="gender" 
                                    class="field">
                              <option value="Male">{{ 'myProfile.dogMale' | translate }}</option>
                              <option value="Female">{{ 'myProfile.dogFemale' | translate }}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (dogsFormArray.length === 0) {
                    <div class="col-span-full py-12 text-center bg-slate-50 dark:bg-slate-800/50 rounded-3xl border-2 border-dashed border-slate-200 dark:border-slate-800">
                      <p class="text-slate-400 font-bold uppercase tracking-widest text-xs">{{ 'myProfile.noDogs' | translate }}</p>
                    </div>
                  }
                </div>
              </div>

              @if (profileForm.invalid && profileForm.touched) {
                <p class="mt-4 text-sm text-red-600" role="alert">{{ translationLanguageIsFrench ? 'Vérifie les prénoms, noms et noms des chiens, ainsi que les années de naissance et âges saisis.' : 'Check first and last names, dog names, birth years and ages.' }}</p>
              }
              @if (profileSaveError()) {
                <p class="mt-4 text-sm text-red-600" role="alert">{{ translationLanguageIsFrench ? 'L’enregistrement a échoué. Tes saisies sont conservées : réessaie.' : 'Saving failed. Your input is preserved: please try again.' }}</p>
              }
              <div class="flex justify-end gap-6 pt-8">
                <button type="button" (click)="toggleEdit()" 
                        class="btn btn-secondary">
                  {{ 'login.cancel' | translate }}
                </button>
                <button type="submit" [disabled]="isLoading()"
                        class="btn btn-primary px-10 py-4">
                  {{ 'myProfile.save' | translate }}
                </button>
              </div>
            </div>
          </div>
        </form>
      }
    }
  </div>
